import { render, staticRenderFns } from "./Blockie.vue?vue&type=template&id=6025aaaa&scoped=true&lang=html&"
import script from "./Blockie.vue?vue&type=script&lang=js&"
export * from "./Blockie.vue?vue&type=script&lang=js&"
import style0 from "./Blockie.vue?vue&type=style&index=0&id=6025aaaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6025aaaa",
  null
  
)

export default component.exports